import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Rails from '@/views/Rails.vue'
import NavNestedView from '@/views/NavNestedView.vue'
import store from '@/store'
import { RouteName, RoutePath } from './routes'

Vue.use(VueRouter)

  const routes: Array<RouteConfig> = [
  {
    path: RoutePath.Index,
    name: RouteName.Index,
    redirect: () => {
      //TODO: Add checks for compliance
      return store.state.initialLaunch ? RoutePath.Welcome : RoutePath.Home;
    }
  },
  {
    path: RoutePath.Home,
    name: RouteName.Home,
    redirect: { name: RouteName.Rails },
    component: NavNestedView,
    children: [
      { path: '',
        name: RouteName.Rails,
        component: Rails 
      },
      {
        path: RoutePath.Settings,
        name: RouteName.Settings,
        component: () => import('../views/Settings.vue')
      },
      {
        path: RoutePath.Discover,
        name: RouteName.Discover,
        component: () => import('../views/Discover.vue')
      },
      {
        path: RoutePath.Profile,
        name: RouteName.Profile,
        redirect: { name: RouteName.UserBookmarks },
        component: () => import('../views/Profile.vue'),
        children: [
          { 
            path: '',
            component: () => import('../views/User.vue'),
            meta: { requiresAuth: true },
            children: [
              {
                path: '',
                name: RouteName.UserBookmarks,
                component: () => import('../views/UserBookmarks.vue'),
                meta: { requiresAuth: true },
              },
              {
                path: RoutePath.UserHistory,
                name: RouteName.UserHistory,
                component: () => import('../views/UserHistory.vue'),
                meta: { requiresAuth: true },
              },
              {
                path: RoutePath.UserDetails,
                name: RouteName.UserDetails,
                component: () => import('../views/UserDetails.vue'),
                meta: { requiresAuth: true },
              }
            ]
          },
          { 
            path: RoutePath.Login,
            name: RouteName.Login,
            component: () => import('../views/Login.vue')
          }
        ]
      },
      {
        path: RoutePath.Live,
        name: RouteName.Live,
        component: () => import('../views/Live.vue')
      },
      {
        path: RoutePath.Search,
        name: RouteName.Search,
        component: () => import('../views/Search.vue')
      },
      
    ],
  },
  
  {
    path: RoutePath.Episode,
    props: true,
    name: RouteName.Episode,
    component: () => import('../views/Episode.vue')
  },
  
  {
    path: RoutePath.Welcome,
    name: RouteName.Welcome,
    component: () => import('../views/Welcome.vue')
  },
  {
    path: RoutePath.Player,
    props: true,
    name: RouteName.Player,
    meta: { unscaled: true },
    component: () => import('../views/Player.vue')
  },
  {
    path: RoutePath.DeeplinkLive,
    props: true,
    name: RouteName.DeeplinkLive,
    component: () => import('../views/DeeplinkLive.vue')
  },
  {
    path: RoutePath.Series,
    props: true,
    name: RouteName.Series,
    component: () => import('../views/Series.vue')
  },
  {
    path: RoutePath.Category,
    props: true,
    name: RouteName.Category,
    component: () => import('../views/Category.vue')
  },
]

const router = new VueRouter({
  routes: routes
})

router.beforeEach(async (to, from, next) => {

  if (to.meta?.requiresAuth == true) {
    if (store.state.token === "") {
      return next({name: RouteName.Login })
    }
  }

  return next()
})

export default router
